var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content-wrappper" }, [
    _c("div", { staticClass: "row m-0" }, [
      _c("div", { staticClass: "col-md-12 p-0" }, [
        _c(
          "form",
          { ref: "form", attrs: { method: "post", target: "my_frame" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.token,
                  expression: "token",
                },
              ],
              attrs: { type: "hidden", name: "token", value: "" },
              domProps: { value: _vm.token },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.token = $event.target.value
                },
              },
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.nextUrl,
                  expression: "nextUrl",
                },
              ],
              attrs: { type: "hidden", name: "nextUrl" },
              domProps: { value: _vm.nextUrl },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.nextUrl = $event.target.value
                },
              },
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.serviceType,
                  expression: "serviceType",
                },
              ],
              attrs: { type: "hidden", name: "serviceType" },
              domProps: { value: _vm.serviceType },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.serviceType = $event.target.value
                },
              },
            }),
          ]
        ),
        _c("iframe", {
          staticClass: "iframe-content",
          attrs: { name: "my_frame", frameborder: "0" },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }